import React from "react";
import useMutationOrganizationUpdate from "./useMutationOrganizationUpdate.js";
import useTranslationOrganization from "../useTranslationOrganization.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useErrorModal from "../../common/modals/useErrorModal.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";
import StringUtils from "../../../utils/StringUtils.js";

/**
 * Generic component for all report editable fields
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function OrganizationInlineEditInput(props) {
  const {
    InlineEditInputComponent,
    organization,
    property,
    className,
    ...otherProps
  } = props;
  const { mutate, loading, errors } = useMutationOrganizationUpdate();
  const { t, loading: tLoading } = useTranslationOrganization();
  useShowLoader(tLoading, "OrganizationInlineEditInput");
  const errorMsg = useServerErrorFormatter(errors);

  const { ErrorModal, show: showErrorModal } = useErrorModal(
    <>
      <p>{t("organization:organization_update_error")}</p>
      {errorMsg}
    </>
  );

  const onSubmit = (value) => {
    const variables = {};
    variables["id"] = organization._id;
    variables[property] = value;
    mutate({ variables }).catch((error) => {
      showErrorModal();
    });
  };

  return (
    <>
      {ErrorModal}
      <div className={["ReportInlineEditInput", className].join(" ")}>
        <InlineEditInputComponent
          value={StringUtils.nullToEmpty(organization[property])}
          onSubmit={onSubmit}
          loading={loading}
          {...otherProps}
        />
      </div>
    </>
  );
}
